
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packs",
      function () {
        return require("private-next-pages/packs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packs"])
      });
    }
  